export const checkIsValidProvince = async (postalCode) => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/validate-province/${postalCode}`
  );

  const { isValid } = await response.json();
  return isValid;
};
